'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
require('../../typography/ErrorText/ErrorText.js');
require('../../typography/LargeDarkText/LargeDarkText.js');
require('../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../typography/MediumDarkText/MediumDarkText.js');
require('../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../typography/MediumText/MediumText.js');
require('../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../typography/MiniatureLinkText/MiniatureLinkText.js');
var SmallDarkText = require('../../typography/SmallDarkText/SmallDarkText.js');
require('../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../typography/SmallLinkText/SmallLinkText.js');
require('../../typography/SmallTitleText/SmallTitleText.js');
require('../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../typography/TinyDarkText/TinyDarkText.js');
require('../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../typography/TinyLinkText/TinyLinkText.js');
require('../../typography/TinyTitleText/TinyTitleText.js');
require('../../typography/XXLargeDarkText/XXLargeDarkText.js');
var MenuItem = _interopDefault(require('@material-ui/core/MenuItem'));
var ArrowDropDown = _interopDefault(require('@material-ui/icons/ArrowDropDown'));
var Select = _interopDefault(require('@material-ui/core/Select'));
var styledComponents = require('./styled-components.js');

var SelectWithLabel = function (props) {
    var Icon = props.Icon, defaultValue = props.defaultValue, error = props.error, _a = props.disabled, disabledInput = _a === void 0 ? false : _a, menuItems = props.menuItems, reporter = props.reporter, _b = props.style, style = _b === void 0 ? {} : _b, _c = props.tall, tall = _c === void 0 ? false : _c, _d = props.title, title = _d === void 0 ? '' : _d, value = props.value;
    var handleChange = function (event) {
        reporter(event.target.value);
    };
    return (React__default.createElement(styledComponents.Main, { style: tslib.__assign({ height: '35px' }, style) },
        typeof title === 'string' && title.length > 0 && (React__default.createElement(styledComponents.StyledInputLabel, null, title)),
        typeof title !== 'string' && title,
        React__default.createElement(Select, { value: value, defaultValue: defaultValue || menuItems[0].value, onChange: handleChange, input: React__default.createElement(styledComponents.StyledInput, { tall: tall, disabled: disabledInput }), IconComponent: Icon || ArrowDropDown, "data-testid": 'select-menu', inputProps: {
                'data-testid': 'select-input',
            }, error: error, style: { height: '100%' } }, menuItems.map(function (_a) {
            var itemValue = _a.value, display = _a.display, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
            return (React__default.createElement(MenuItem, { key: itemValue, value: itemValue, disabled: disabled },
                React__default.createElement(SmallDarkText, null, display)));
        }))));
};

module.exports = SelectWithLabel;
